import { FILE_STATES } from "./consts";
const BISYM = Symbol.for("__rpldy-bi__");
let iCounter = 0;
const getBatchItemWithUrl = (batchItem, url) => {
  batchItem.url = url;
  return batchItem;
};
const getBatchItemWithFile = (batchItem, file) => {
  batchItem.file = file;
  return batchItem;
};
const isLikeFile = f => f && (f instanceof File || f instanceof Blob || !!(typeof f === "object" && f.name && f.type));
const getIsBatchItem = obj => {
  return !!(typeof obj === "object" && obj.id && obj.batchId && obj[BISYM] === true);
};
const createBatchItem = function (f, batchId) {
  let isPending = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  const isAlreadyBatchItem = getIsBatchItem(f);
  iCounter += isAlreadyBatchItem ? 0 : 1;

  //keep existing id for recycled items
  const id = isAlreadyBatchItem && f.id && typeof f.id === "string" ? f.id : `${batchId}.item-${iCounter}`,
    state = isPending ? FILE_STATES.PENDING : FILE_STATES.ADDED;
  let batchItem = {
    id,
    batchId,
    state,
    uploadStatus: 0,
    total: 0,
    completed: 0,
    loaded: 0,
    recycled: isAlreadyBatchItem,
    // $FlowIssue[prop-missing] - flow just doesnt understand...
    previousBatch: isAlreadyBatchItem ? f.batchId : null
  };
  Object.defineProperty(batchItem, BISYM, {
    value: true,
    //need writable to be able to keep prop when unwrapped from simple-state
    writable: true
  });

  //$FlowIssue[prop-missing] - flow just doesnt understand...
  const fileData = isAlreadyBatchItem ? f.file || f.url : f;
  if (typeof fileData === "string") {
    batchItem = getBatchItemWithUrl(batchItem, fileData);
  } else if (isLikeFile(fileData)) {
    batchItem = getBatchItemWithFile(batchItem, fileData);
  } else {
    throw new Error(`Unknown type of file added: ${typeof fileData}`);
  }
  return batchItem;
};
export default createBatchItem;
export { getIsBatchItem };